<template>
  <div id="list_demo">
    <highlight></highlight>
  </div>
</template>

<script>
  import Banner from '@/components/Banner'
  import Highlight from '@/components/Highlights'
  import MenuEmp from '@/components/Menu'
  export default {
    name: 'list-demo',
    components: { MenuEmp, Banner,Highlight}
  }
</script>



// WEBPACK FOOTER //
// ListDemo.vue?fc68fb48